import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Game from './Game';
import GameObject from './GameObject/GameObject';
import { sentryInit } from './Sentry';
import Environment from './Utility/Environment';
import { GameCheats } from './Cheats';
import CheatsManager from "CheatsManager";
import { getGameConfig } from '@platform/GameConfig';
import './Utility/PixiExtends';
import { LanguageKey } from 'Utility/SDK/Language';

declare global {
    interface Window {
        game: typeof Game;
        GameObject: typeof GameObject;
        sgPlatform: string;
    }
}

function sentryInitAfterGameConfig() {
    /*if (process?.env.NODE_ENV === Environment.PRODUCTION) {
        sentryInit();
    }*/
}

new CheatsManager({
    autoEnableCheats: process?.env.NODE_ENV === Environment.DEVELOPMENT,
    enableCheatsFunc: () => {
        (window as any).cheats = GameCheats;
        window.game = Game;
    },
});

getGameConfig().then(config => {
    PIXI.utils.skipHello();
    config.language = getParameterByName("lang") as LanguageKey;
    
    return Game.init(config)
        .then(() => Game.sdk.initDDNA())
        .then(() => sentryInitAfterGameConfig());
});

function getParameterByName(name:string, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
